import { cn } from '@/utils/cn';

/**
 * Placeholder block standing in for content that has not arrived. Decorative, like {@link Spinner}:
 * announcing it is the caller's job, through the `role="status"` region it wraps the skeleton in.
 */
export function Skeleton({ className }: { readonly className?: string }): React.JSX.Element {
  return (
    <span aria-hidden="true" className={cn('animate-skeleton block rounded bg-surface-stronger', className)} />
  );
}
